import { createImageData } from "canvas";
import type { Bitmap } from "./types.ts";
import { bitmapChannels } from "./types.ts";
import { uint8ArrayAllocUnsafe } from "../utils/uint8-array.ts";

// Note: Image data interface almost identical to bitmap. Can we re-use underlying data
// in some circumstances to be more efficient?
function bitmapToImageData(image: Bitmap) {
	return createImageData(
		// Sometime the data itself is longer
		Uint8ClampedArray.from(
			image.data.subarray(0, image.width * image.height * bitmapChannels),
		),
		image.width,
		image.height,
	) as ImageData;
}

function imageDataToBitmap(
	imageData: Pick<ImageData, "data" | "width" | "height">,
): Bitmap {
	const length = imageData.width * imageData.height * bitmapChannels;
	const data = uint8ArrayAllocUnsafe(length);
	// Bulk-copy the RGBA bytes in one sequential (cache-friendly) pass, then
	// force every alpha lane to fully opaque. Equivalent to the previous
	// per-pixel pack, which discarded the source alpha and always wrote 0xff.
	data.set(imageData.data.subarray(0, length));
	for (let i = bitmapChannels - 1; i < length; i += bitmapChannels) {
		data[i] = 0xff;
	}
	return {
		data,
		width: imageData.width,
		height: imageData.height,
	};
}

export { bitmapToImageData, imageDataToBitmap };
